import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AdminLayout } from './layouts/AdminLayout';
import './styles.css';

const DashboardPage = lazy(() => import('./pages/dashboard'));
const ProvidersPage = lazy(() => import('./pages/providers'));
const ReadingsPage = lazy(() => import('./pages/readings'));
const LogsPage = lazy(() => import('./pages/logs'));
const TerminologyPage = lazy(() => import('./pages/terminology'));

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: '#1677ff', borderRadius: 8 } }}><AntApp><BrowserRouter><Suspense fallback={null}><Routes><Route element={<AdminLayout />}><Route path="/" element={<DashboardPage />} /><Route path="/providers" element={<ProvidersPage />} /><Route path="/readings" element={<ReadingsPage />} /><Route path="/logs" element={<LogsPage />} /><Route path="/terminology" element={<TerminologyPage />} /></Route></Routes></Suspense></BrowserRouter></AntApp></ConfigProvider></React.StrictMode>);
